import { WithIconTextareaFormInput } from "../generic/forms/withIconTextAreaFormInput";
import { SvgEnvelop } from "../../assets/icons";

export const ForgetPasswordForm = () => {
  return (
    <div className="d-flex flex-column align-items-center">
      <WithIconTextareaFormInput
        className="ms-2 p-0 w-100 me-2 mt-3"
        name="userId"
        placeholder="Email"
        svgicon={SvgEnvelop}
      />
    </div>
  );
};
